// @ts-nocheck
(function () {
  'use strict';

  var DEFAULT_M2 = 1.44;
  var debounce;

  function getUpsellEl() {
    return document.querySelector('.sly-upsell-permanent');
  }

  function getCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function () {});
  }

  function calcTubes(cart, productId) {
    var m2 = 0, inCart = 0;
    (cart.items || []).forEach(function (item) {
      if (String(item.product_id) === String(productId)) {
        inCart += item.quantity;
        return;
      }
      var pp = parseFloat((item.properties || {})['_m2_per_plaat']) || DEFAULT_M2;
      m2 += item.quantity * pp;
    });
    return { m2: m2, needed: Math.ceil(m2), inCart: inCart };
  }

  function updateWidget(cart) {
    var el = getUpsellEl();
    if (!el) return;

    var productId = el.getAttribute('data-product-id') || '15438957019513';
    var c = calcTubes(cart, productId);

    var subEl = document.getElementById('sly-upsell-sub');
    var qtyInput = document.getElementById('sly-upsell-qty');

    if (subEl) {
      var unit = el.getAttribute('data-txt-unit') || 'koker';
      var recommended = el.getAttribute('data-txt-recommended') || 'aanbevolen voor';
      var perM2 = el.getAttribute('data-txt-per-m2') || 'per 1,44 m\u00b2 wandpaneel';
      if (c.m2 > 0) {
        subEl.textContent = c.needed + ' ' + unit + (c.needed !== 1 ? 's' : '') + ' ' + recommended + ' ' + c.m2.toFixed(1) + ' m\u00b2';
      } else {
        subEl.textContent = '1 ' + unit + ' ' + perM2;
      }
    }

    // Set suggested qty = needed minus what's already in cart (min 1)
    if (qtyInput && qtyInput !== document.activeElement) {
      var suggested = Math.max(1, c.needed - c.inCart);
      qtyInput.value = suggested;
    }
  }

  function refreshCartSection(cb) {
    var comp = document.querySelector('cart-items-component[data-drawer]') ||
               document.querySelector('cart-items-component');
    var sectionId = comp ? comp.getAttribute('data-section-id') : null;
    if (!sectionId) {
      var wrapper = document.querySelector('[id^="shopify-section-cart"]');
      if (wrapper) sectionId = wrapper.id.replace('shopify-section-', '');
    }
    if (!sectionId) { if (cb) cb(); return; }

    fetch('/cart?sections=' + sectionId)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: null, data: { sections: sections, didError: false } }
        }));
        if (cb) setTimeout(cb, 300);
      })
      .catch(function () { if (cb) cb(); });
  }

  window.slyUpsellQty = function (delta) {
    var input = document.getElementById('sly-upsell-qty');
    if (!input) return;
    input.value = Math.max(1, Math.min(99, (parseInt(input.value) || 1) + delta));
  };

  window.slyPistoolQty = function (delta) {
    var input = document.getElementById('sly-pistool-qty');
    if (!input) return;
    input.value = Math.max(1, Math.min(99, (parseInt(input.value) || 1) + delta));
  };

  window.stonelyAddPistool = function (variantId) {
    var qty = parseInt((document.getElementById('sly-pistool-qty') || {}).value) || 1;
    var btn = document.getElementById('sly-pistool-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartSection(function () { getCart(updateWidget); });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Toevoegen'; }
      })
      .finally(function () {
        setTimeout(function () {
          var b = document.getElementById('sly-pistool-btn');
          if (b) { b.disabled = false; b.textContent = 'Toevoegen'; }
        }, 800);
      });
  };

  window.stonelyAddSilicone = function () {
    var el = getUpsellEl();
    if (!el) return;

    var variantId = parseInt(el.getAttribute('data-variant-id')) || 0;
    if (!variantId) {
      // Fallback: fetch from product JS
      fetch('/products/soudal-fix-all-turbo-wit-290ml.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
          if (v) {
            el.setAttribute('data-variant-id', v.id);
            doAdd(v.id);
          }
        });
      return;
    }
    doAdd(variantId);
  };

  function doAdd(variantId) {
    var qty = parseInt((document.getElementById('sly-upsell-qty') || {}).value) || 1;
    var btn = document.getElementById('sly-upsell-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Bezig\u2026'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function () {
        refreshCartSection(function () {
          getCart(updateWidget);
        });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'Toevoegen'; }
      })
      .finally(function () {
        setTimeout(function () {
          var b = document.getElementById('sly-upsell-btn');
          if (b) { b.disabled = false; b.textContent = 'Toevoegen'; }
        }, 800);
      });
  }

  function debouncedUpdate() {
    clearTimeout(debounce);
    debounce = setTimeout(function () { getCart(updateWidget); }, 200);
  }

  // ── Drawer layout: verplaats upsell-widgets naar het scrollgebied ──
  var layoutTimer;

  function slyDrawerLayout() {
    var component = document.querySelector('cart-drawer-component');
    if (!component) return;
    var cartItemsComp = component.querySelector('cart-items-component');
    var items = component.querySelector('.cart-drawer__items');   // inner scroll container
    var summary = component.querySelector('.cart-drawer__summary');
    if (!cartItemsComp || !items || !summary) return;

    // Verplaats upsell-widgets naar het items-scrollgebied (zodat ze meescrollen)
    var upsells = Array.prototype.slice.call(summary.querySelectorAll('.sly-upsell-permanent'));
    upsells.forEach(function (u) { items.appendChild(u); });

    // Verplaats summary buiten de scroll-hint naar cart-items-component
    if (summary.parentElement !== cartItemsComp) {
      cartItemsComp.appendChild(summary);
    }
  }

  function initDrawerLayout() {
    slyDrawerLayout();
    var component = document.querySelector('cart-drawer-component');
    if (!component) return;
    var observer = new MutationObserver(function () {
      clearTimeout(layoutTimer);
      layoutTimer = setTimeout(slyDrawerLayout, 200);
    });
    // Observeer cart-items-component voor herrendering na cart-updates
    var cartItemsComp = component.querySelector('cart-items-component');
    if (cartItemsComp) {
      observer.observe(cartItemsComp, { childList: true, subtree: false });
    }
  }

  function init() {
    // Update widget on cart changes
    document.addEventListener('cart:update', debouncedUpdate);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.cart-form, #cart-form, cart-items-component')) {
        debouncedUpdate();
      }
    });

    // Initial update
    if (getUpsellEl()) getCart(updateWidget);

    // Drawerlay-out: upsell buiten vaste sectie
    initDrawerLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
